import { useState, useEffect, lazy, Suspense } from 'react'
import { PREVIEW_READY, PREVIEW_DATA, PREVIEW_CONFIG, type PreviewContentType } from 'common/preview-protocol'
import { loadGoogleFontsForObjects } from 'common/google-fonts'
import { ChannelPlayer } from './ChannelPlayer'
import { PlaylistPlayer } from './PlaylistPlayer'

const CanvasLayoutPlayer = lazy(() => import('./CanvasLayoutPlayer').then((m) => ({ default: m.CanvasLayoutPlayer })))

export const LivePreviewHost = () => {
  const [contentType, setContentType] = useState<PreviewContentType | null>(null)
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    // Signal parent that we are ready to receive data
    window.parent.postMessage({ type: PREVIEW_READY }, '*')

    const handler = (event: MessageEvent) => {
      if (event.data?.type === PREVIEW_DATA) {
        setContentType(event.data.contentType)
        setData(event.data.data)
      }
      if (event.data?.type === PREVIEW_CONFIG) {
        // Reserved for future config like aspect ratio, background
      }
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [])

  // Load Google Fonts for canvas layout objects
  useEffect(() => {
    if (contentType === 'canvasLayout' && data?.canvasData?.objects) {
      loadGoogleFontsForObjects(data.canvasData.objects)
    }
  }, [contentType, data])

  if (!contentType || !data) {
    return (
      <div className="w-full h-full bg-black flex items-center justify-center">
        <span className="text-white/30 text-sm">Waiting for preview data...</span>
      </div>
    )
  }

  return (
    <div className="relative w-full h-full">
      {contentType === 'channel' && <ChannelPlayer channelData={data} isPreview />}
      {contentType === 'playlist' && <PlaylistPlayer playlistData={data} isPreview />}
      {contentType === 'canvasLayout' && (
        <Suspense fallback={null}>
          <CanvasLayoutPlayer layoutData={data} isPreview />
        </Suspense>
      )}
    </div>
  )
}
